import React from 'react'

function Pague404() {
  return (
    <div className='text-center' > <i className="fa fa-spinner fa-spin fa-3x"></i></div>
  )
}

export default Pague404